import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file 触发一次render
 * @author alfielv
 */
import { useReducer } from 'react';

var updateReducer = function updateReducer(num) {
  return (num + 1) % 1000000;
};

export default (function () {
  var _useReducer = useReducer(updateReducer, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      update = _useReducer2[1];

  return update;
});